import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { AuthLayoutComponent } from '../auth-layout/auth-layout.component';

@Component({
  selector: 'app-auth-page',
  templateUrl: './auth-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AuthLayoutComponent, RouterOutlet],
})
export class AuthPageComponent {}
